import OutletButton from 'components/outletButton';
import {sorts} from 'models/postOrder';
import {sortToPersian} from 'utilities/helper/sortToPersian';

const Title = ({setIsSortOpen, isSortOpen, sortFilter}: IBuyersTitleProps) => {
  return (
    <>
      <div className="flex justify-between">
        <span className="text-gray-6">آگهی ها</span>
        <OutletButton
          onClick={() => setIsSortOpen(!isSortOpen)}
          title={sortFilter ? sortToPersian[sortFilter] : sorts[0].title}
          icon="icon-ordering"
        />
      </div>
    </>
  );
};

export default Title;
